'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = MonthSelect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function MonthSelect(p) {
    var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    var monthOptions = months.map(function (month) {
        return _react2['default'].createElement(
            'option',
            { key: month, value: month },
            month
        );
    });

    var value = p.value || '01';

    return _react2['default'].createElement(
        'select',
        { className: 'm-payment--cc-exp-month', value: value, onChange: p.onChange },
        monthOptions
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/month-select.jsx
 ** module id = 1122
 ** module chunks = 0
 **/